module.exports = __webpack_public_path__ + "img/shops_selected.b2541dc9.svg";